import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const CasinoCherryIcon = observer(
    'CasinoCherryIcon',
    ({ className, onClick }: SvgIconPropsType): JSX.Element => {
        return (
            <SvgIcon
                className={className}
                height='24'
                onClick={onClick}
                viewBox='0 0 24 24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    clipRule='evenodd'
                    fill='currentColor'
                    fillRule='evenodd'
                    d='M16.868 13.436c-1.135-2.445-.726-5.704.254-8.045.46-.164-.44-.452-.775-.39-3.527.663-6.734 3.001-7.962 6.419-2.34-2.333-5.922-.035-5.807 3.367.095 2.805 1.74 4.897 4.353 5.37 3.79.687 6.404-2.928 6.524-5.435.114-2.357-1.798-3.725-3.912-3.059.967-2.95 3.519-5.12 6.46-5.981-.865 2.294-1.178 5.198-.235 7.521-.503-.506-1.063-.8-1.633-.913.364.652.575 1.413.572 2.23 0 .073 0 .155-.005.264-.125 1.95-1.28 4.24-3.28 5.578a5.112 5.112 0 0 0 2.872 1.553c3.79.686 6.404-2.929 6.525-5.435.114-2.37-1.82-3.738-3.951-3.044Zm-5.843 1.957.003.004a.461.461 0 0 1 .542-.379.47.47 0 0 1 .38.543c-.305 1.639-1.61 2.925-3.172 2.938 0 0-.019-.003-.016 0-.017.002-.032.002-.048.002a.47.47 0 0 1-.058-.936c.047-.005.08-.005.1-.005h.023c1 .014 2.02-.906 2.246-2.166Zm4.958 4.862s-.019-.003-.019 0c-.017.002-.035.002-.052.002a.469.469 0 0 1-.05-.933c.075-.01.112-.007.121-.007.999.014 2.021-.906 2.248-2.166v.003a.468.468 0 1 1 .922.165c-.301 1.637-1.61 2.922-3.17 2.936ZM14.975 3.589s-1.656-2.336-4.633-1.343c-1.518.507-2.794 1.543-3.563 2.422 1.363.913 2.816 1.251 4.468 1.145 1.31-.09 2.697-.922 3.729-2.224Z'
                />
            </SvgIcon>
        );
    }
);
